import i18n from './i18n';

export const arrayTitle = [
    { type: 'regulations', title: i18n.global.t('t-regulation') },
    { type: 'decisions', title: i18n.global.t('t-decision') },
    { type: 'notifications', title: i18n.global.t('t-notification') },
    { type: 'power-of-attorney', title: i18n.global.t('t-power-of-attorney') },
    { type: 'about-company', title: i18n.global.t('t-about') },
    { type: 'rules-company', title: i18n.global.t('t-rules') },
    { type: 'cultural-company', title: i18n.global.t('t-cultural') },
    { type: 'contract', title: i18n.global.t('t-contract') },
    { type: 'lead', title: i18n.global.t('t-lead') },
    { type: 'danhsachbaogia', title: i18n.global.t('t-danhsachbaogia') },
];
// export const arrayContractTerm = [
//     { code: '1thang', name: i18n.global.t('1thang') },
//     { code: '2thang', name: i18n.global.t('2thang') },
//     { code: '3thang', name: i18n.global.t('3thang') },
//     { code: '6thang', name: i18n.global.t('6thang') },
//     { code: '1nam', name: i18n.global.t('1nam') },
//     { code: '3nam', name: i18n.global.t('3nam') },
//     { code: 'khongxacdinh', name: i18n.global.t('khongxacdinh') },
// ];
// export const arrayStatusSignContract = [
//     { code: '1', name: i18n.global.t('chuaky') },
//     { code: '2', name: i18n.global.t('daky') },
// ];
// export const arrayStatusContract = [
//     { code: '1', name: i18n.global.t('hethieuluc') },
//     { code: '2', name: i18n.global.t('cohieuluc') },
// ];
// export const arrayContractType = [
//     { code: '1', name: i18n.global.t('thuviec') },
//     { code: '2', name: i18n.global.t('hdxdtime') },
//     { code: '3', name: i18n.global.t('hdkxdtime') },
//     { code: '4', name: i18n.global.t('hocviec') },
//     { code: '5', name: i18n.global.t('hdmuavu') },
//     { code: '6', name: i18n.global.t('hddichvu') },
// ];
// export const arrayWorkingForm = [
//     { code: '1', name: i18n.global.t('toanthoigian') },
//     { code: '2', name: i18n.global.t('banthoigian') },
//     { code: '3', name: i18n.global.t('congtacvien') },
// ];
export const arrayAllowance = [
    { code: '1', name: i18n.global.t('phucaptienan') },
    { code: '2', name: i18n.global.t('phucapxangxe') },
    { code: '3', name: i18n.global.t('phucapdienthoai') },
];
export const arrayStatusContact = [
    { code: '1', name: i18n.global.t('lead.chualienhe') ,class:'select-custom-1'},
    { code: '2', name: i18n.global.t('lead.dalienhe') ,class:'select-custom-2'},
    { code: '3', name: i18n.global.t('lead.dabaogia') ,class:'select-custom-3'},
    { code: '4', name: i18n.global.t('lead.khongphanhoi') ,class:'select-custom-4'},
];

export const arrayUnitPrices=[
    { code: "khach", name: i18n.global.t("khach") },
    { code: "phong", name: i18n.global.t("phong") },
    { code: "goi", name: i18n.global.t("goi") },
    { code: "ve", name: i18n.global.t("ve") },
    { code: "xe", name: i18n.global.t("xe") },
    { code: "ghe", name: i18n.global.t("ghe") },
    { code: "dem", name: i18n.global.t("dem") },
    { code: "luot", name: i18n.global.t("luot") },
    { code: "bua", name: i18n.global.t("bua") },
];

export const arrayAgeGroups=[
    { code: "nguoilon", name: i18n.global.t("nguoilon") },
    { code: "treem", name: i18n.global.t("treem") },
    { code: "embe", name: i18n.global.t("embe") },
    { code: "khac", name: i18n.global.t("khac") },
];

export const tinhchatlaodongArray=[
    { code: "hocviec", name: i18n.global.t("hocviec") },
    { code: "thuviec", name: i18n.global.t("thuviec") },
    { code: "chinhthuc", name: i18n.global.t("chinhthuc") },
];

export const chucnnangArray=[
    { code: "other", name: i18n.global.t("other") },
    { code: "department", name: i18n.global.t("phongban") },
    { code: "job_position", name: i18n.global.t("vitricongviec") },
];
// export const arrayStatusWork=[
//     { code: "chuahoanthanh", name: i18n.global.t("chuahoanthanh") },
//     { code: "dahoanthanh", name: i18n.global.t("dahoanthanh") },
// ];
// export const arrayStatusAppoiinted=[
//     { code: "dangthuchien", name: i18n.global.t("procedure.dangthuchien") },
//     { code: "dahoanthanh", name: i18n.global.t("procedure.dahoanthanh") },
//     { code: "hethieuluc", name: i18n.global.t("procedure.hethieuluc") },
//     { code: "dataibonhiem", name: i18n.global.t("procedure.dataibonhiem") },
//     { code: "dungbonhiem", name: i18n.global.t("procedure.dungbonhiem") },
// ];

export const TYPE_APPOINTED = 'appointed';
export const TYPE_DISMISS = 'dismiss';
export const TYPE_DISPLACEMENT = 'displacement';

export const arrayTypeJob=[
    { code: "cohuu", name: i18n.global.t("nvcohuu") },
    { code: "ctv", name: i18n.global.t("ctv") },
];